import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule }    from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ViewHorseComponent } from './view-horse/view-horse.component';
import { EditHorseComponent } from './edit-horse/edit-horse.component';
import { ListUserHorsesComponent } from './list-user-horses/list-user-horses.component';
import { ModalChooseHorseComponent } from './modal-choose-horse/modal-choose-horse.component';
import { ModalAddHorseComponent } from './modal-add-horse/modal-add-horse.component';
import { ModalUsefHorseSearchComponent } from './modal-usef-horse-search/modal-usef-horse-search.component';

import { AddHorseViewService } from './providers/add-horse-view.service';
import { MyHorsesComponent } from './my-horses/my-horses.component';
import { ModalNsbaHorseSearchComponent } from './modal-nsba-horse-search/modal-nsba-horse-search.component';

@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    FontAwesomeModule
  ],
  providers: [ AddHorseViewService ],
  exports: [ ViewHorseComponent, EditHorseComponent ],
  declarations: [ViewHorseComponent,
    EditHorseComponent,
    ListUserHorsesComponent,
    ModalChooseHorseComponent,
    ModalAddHorseComponent,
    ModalUsefHorseSearchComponent,
    MyHorsesComponent, ModalNsbaHorseSearchComponent]
})
export class HorsesModule { }
